import { useLayoutEffect } from 'react';
import { useMediaQuery } from 'react-responsive';

const MOBILE_VIEWPORT = 'width=device-width, initial-scale=1, maximum-scale=1';
const DESKTOP_VIEWPORT = 'width=1024px';

function setViewportMeta(content: string) {
  document
    .querySelector('meta[name=viewport]')
    ?.setAttribute('content', content);
}

export function setDesktopViewport() {
  setViewportMeta(DESKTOP_VIEWPORT);
}

export function useResetMobileViewport() {
  useLayoutEffect(() => {
    setViewportMeta(MOBILE_VIEWPORT);
  }, []);
}

export function useResponsive(): {
  isLgWidth: boolean;
  isMdWidth: boolean;
  isSmWidth: boolean;
  isXsWidth: boolean;
} {
  const isLgWidth = useMediaQuery({
    query: '(min-width: 961px)'
  });
  const isMdWidth = useMediaQuery({
    query: '(max-width: 960px)'
  });
  const isSmWidth = useMediaQuery({
    query: '(max-width: 769px)'
  });
  const isXsWidth = useMediaQuery({
    query: '(max-width: 481px)'
  });

  return {
    isLgWidth,
    isMdWidth,
    isSmWidth,
    isXsWidth
  };
}
